import password_rejected from './password-rejected.js';
const error = {
    general_required: '{{types, list(type: disjunction;)}}必填',
    general_invalid: '无效的{{types, list(type: disjunction;)}}',
    invalid_min_max_input: '输入值应在 {{minValue}} 和 {{maxValue}} 之间',
    invalid_min_max_length: '输入值的长度应在 {{minLength}} 和 {{maxLength}} 之间',
    username_required: '用户名必填',
    password_required: '密码必填',
    username_exists: '用户名已存在',
    username_should_not_start_with_number: '用户名不能以数字开头',
    username_invalid_charset: '用户名只能包含英文字母、数字或下划线。',
    username_too_short: '用户名长度至少为 {{min}} 个字符。',
    username_too_long: '用户名长度至多为 {{max}} 个字符。',
    username_uppercase_not_allowed: '用户名中不允许使用大写字母。',
    username_lowercase_not_allowed: '用户名中不允许使用小写字母。',
    username_numbers_not_allowed: '用户名中不允许使用数字。',
    username_underscore_not_allowed: '用户名中不允许使用下划线。',
    invalid_email: '无效的邮箱',
    invalid_phone: '无效的手机号',
    passwords_do_not_match: '两次输入的密码不一致。',
    invalid_passcode: '无效的验证码。',
    device_code_required: '请输入代码。',
    invalid_device_code: '设备代码无效。',
    device_flow_aborted: '登录请求已中断。',
    invalid_connector_auth: '登录失败',
    invalid_connector_request: '无效的登录请求',
    unknown: '未知错误，请稍后重试。',
    invalid_session: '未找到会话，请返回并重新登录。',
    timeout: '请求超时，请稍后重试。',
    password_rejected,
    sso_not_enabled: '此邮箱账户未启用单点登录。',
    invalid_link: '无效的链接',
    invalid_link_description: '你的一次性令牌可能已过期或不再有效。',
    captcha_verification_failed: '验证码验证失败。',
    send_verification_code_failed: '验证码发送失败，请稍后再试。',
    send_verification_code_failed_use_password: '验证码发送失败，请改用密码登录。',
    terms_acceptance_required: '需要同意条款',
    terms_acceptance_required_description: '必须同意条款后才能继续。',
    something_went_wrong: '出现错误',
    account_suspended: '账户已停用',
    account_suspended_description: '该账户已被停用，请联系管理员获取帮助。',
    access_denied: '访问被拒绝',
    application_access_denied: '您没有权限访问此应用。\n请联系管理员寻求帮助。',
    feature_not_enabled: '您没有权限访问此功能。请联系管理员寻求帮助。',
    wallet_not_found: '未检测到以太坊钱包。请安装浏览器钱包扩展后重试。',
    wallet_not_supported: '钱包登录仅支持安装了钱包扩展的浏览器。',
    wallet_request_rejected: '钱包请求已被拒绝，请重试。',
    wallet_unsupported_chain: '钱包连接到了不支持的网络，请切换网络后重试。',
    wallet_signature_invalid: '钱包签名无效或已过期，请重试。',
};
export default Object.freeze(error);
